module.exports = __webpack_public_path__ + "img/special2-1.3ef05792.png";